import { take, spawn } from 'redux-saga/effects'
import { REHYDRATE } from 'redux-persist/lib/constants'

import kioskModeSaga from '../kiosk/sagas'
import contributionsSaga from './contributions'
import { rootSaga as fullscreenSaga } from '../kiosk/fullscreen/sagas'
import apiSaga from 'civic-champs-shared/api/saga'
import featuresSaga from '../core/feature/sagas'

// Spawned rather than forked: these top-level sagas are independent, and a forked task that
// throws cancels its parent along with every sibling. On an unattended kiosk that meant one
// uncaught error silently killed roster polling, volunteer search and check-in while the
// kiosk screen stayed on display.
export default function* rootSaga() {
  console.log('waiting for rehydration')
  yield take(REHYDRATE)
  console.log('rehydrated')

  yield spawn(kioskModeSaga)
  yield spawn(fullscreenSaga)
  yield spawn(contributionsSaga)
  yield spawn(apiSaga)
  yield spawn(featuresSaga)
}
